export const xReqId = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
  /[xy]/g,
  function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  }
);

export const generateXReqId = () =>
	"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, c => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	}
);

export const formatDateFromUnixTimestamp = (timestamp, time = false) => {
  const date = new Date(timestamp);
  const options = {
    ...(time
      ? {
          hour: "numeric",
          minute: "numeric",
          hour12: false,
        }
      : {}),
  };
  const formattedDate = new Intl.DateTimeFormat("el-GR", options).format(date);
  return formattedDate.replace(",", "");
};

export const dateFormatter = (type, date) => {
  if (type === "date") {
    return date === "-" ? "-" : formatDateFromUnixTimestamp(date);
  }

  if (type === "hour") {
    return date === "-" ? "-" : formatDateFromUnixTimestamp(date, true);
  }
};

export const concatenateDate = (value) => {
  return `${dateFormatter("date", value)} ${dateFormatter("hour", value)}`;
};

export const documentTypeFormatter = (type) => {
  switch (type) {
    case "PASSPORT": {
      return "Διαβατήριο";
    }
    case "NATIONAL_ID": {
      return "Ταυτότητα";
    }
    case "FOREIGN_ID": {
      return "Ταυτότητα αλλοδαπού";
    }
    case "VIGNETTE": {
      return "Βινιέτα";
    }
    case "RESIDENCE_PERMIT": {
      return "Δελτίο διαμονής";
    }
    case "CERTIFICATE_APPLICATION": {
      return "Βεβαίωση κατάθεσης";
    }
    case "RESIDENCE_PERMIT_PERMANENT": {
      return "Δελτίο μόνιμης διαμονής";
    }
    case "RESIDENCE_PERMIT_SPECIAL": {
      return "Ειδική βεβαίωση νόμιμης διαμονής";
    }
    case "STANDALONE_DOCUMENT": {
      return "Αυτοτελές έγγραφο";
    }
    case "ELECTRONIC_APPLICATION": {
      return "Ηλεκτρονική αίτηση";
    }
    default: {
      return "-";
    }
  }
};

export const isObjectEmpty = (obj) => {
  return Object.keys(obj).length === 0;
};

export const checkQueryParam = (name) => {
  const url = new URL(window.location.href);
  return url.searchParams.has(name);
};

export const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
